import React, { useEffect, useRef, useState } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PrimeReact from 'primereact/api';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

import { useHistory } from 'react-router-dom';
import { useToast } from '../../../hooks/toast';
import { Container } from './styles';
import api from '../../../services/api';

 interface IInterventionProperties {
  natureza_interv_id: number | null;
  natureza_interv_descricao: string;
}

const Intervention: React.FC = () => {
  // active ripple effect
  PrimeReact.ripple = true;

  const emptyIntervention = {
    natureza_interv_id: null,
    natureza_interv_descricao: '',
  };

  const [interventions, setInterventions] = useState<IInterventionProperties[]>([]);
  const [intervention, setIntervention] = useState(emptyIntervention);
  const [deleteIntervention, setDeleteInterventionDialog] = useState(false);
  const [deleteInterventionsDialog, setDeleteInterventionsDialog] = useState(false);
  const [selectedInterventions, setSelectedInterventions] = useState<IInterventionProperties[]>([]);

  // para tabela
  const [globalFilter, setGlobalFilter] = useState('');
  const dt = useRef(null);
  const { addToast } = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const response = await api.get('/lawsuits/interventions/show/all');
      setInterventions(response.data);
    })();
  }, []);

  const columns = [
    { field: 'natureza_interv_id', header: 'Código', sortable: true },
    { field: 'natureza_interv_descricao', header: 'Descrição', sortable: true },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column
      key={col.field}
      field={col.field}
      header={col.header}
      sortable
    />
  ));

  const handleCreate = () => {
    history.push('/lawsuit/intervention/create');
  };

  const hidedeleteIntervention = () => {
    setDeleteInterventionDialog(false);
  };

  const hidedeleteInterventionsDialog = () => {
    setDeleteInterventionsDialog(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const editIntervention = (rowData:any) => {
    history.push(`/lawsuit/intervention/edit/${rowData.natureza_interv_id}`);
  };

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const confirmDeleteIntervention = (intervention: React.SetStateAction<{
    natureza_interv_id: null; natureza_interv_descricao: string;
  }>) => {
    setIntervention(intervention);
    setDeleteInterventionDialog(true);
  };

  const deleteGroup = () => {
    api.delete(`/lawsuits/interventions/delete/${intervention.natureza_interv_id}`);

    setDeleteInterventionDialog(false);

    const updatedRecords = interventions
      .filter((val) => val.natureza_interv_id !== intervention.natureza_interv_id);
    setInterventions(updatedRecords);

    addToast({
      type: 'success',
      title: 'Cadastro excluído!',
      description:
        'O cadastro selecionado foi excluído com sucesso!',
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const actionBodyTemplate = (rowData: any) => (
    <>
      <Button
        type="button"
        icon="pi pi-pencil"
        tooltip="Alterar cadastro"
        tooltipOptions={{ position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain p-mr-2"
        onClick={() => { editIntervention(rowData); }}
      />
      <Button
        type="button"
        icon="pi pi-trash"
        tooltip="Excluir cadastro"
        tooltipOptions={{ className: 'red-tooltip', position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain"
        onClick={() => { confirmDeleteIntervention(rowData); }}
      />
    </>
  );

  const header = (
    <div className="flex align-items-center export-buttons">
      <Button
        type="button"
        label="Novo"
        icon="pi pi-plus"
        className="p-button-primary p-mr-2"
        onClick={handleCreate}
        tooltip="Novo cadastro"
        tooltipOptions={{ position: 'right' }}
      />
      <span className="p-input-icon-left p-ml-auto">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar na tabela" />
      </span>
    </div>
  );

  const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />;
  const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />;

  const deleteInterventionFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteIntervention} />
      <Button type="button" label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteGroup} />
    </>
  );
  const deleteInterventionsDialogFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteInterventionsDialog} />
    </>
  );

  return (
    <Container>
      <header>
        <div>
          <h1>Naturezas da Intervenção</h1>
        </div>
      </header>

      <div className="datatable-responsive">

        <div className="card">

          <Tooltip target=".export-buttons>button" position="bottom" />

          <DataTable
            tableClassName="table-interventions table"
            id="table-interventions"
            ref={dt}
            value={interventions}
            editMode="row"
            dataKey="natureza_interv_id"
            header={header}
            stripedRows
            className="p-datatable-sm"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords}"
            rows={50}
            rowsPerPageOptions={[10, 20, 50]}
            paginatorLeft={paginatorLeft}
            paginatorRight={paginatorRight}
            globalFilter={globalFilter}
            emptyMessage="Nenhum registro encontrado."
            selectionMode="multiple"
            selection={selectedInterventions}
            onSelectionChange={(e) => {
              const selInterventions = e.value as IInterventionProperties[];
              setSelectedInterventions(selInterventions);
            }}
            onRowDoubleClick={(e) => editIntervention(e.data)}
          >
            {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} /> */}
            {dynamicColumns}
            <Column body={actionBodyTemplate} align="right" style={{ width: '120px' }} />
          </DataTable>

        </div>

        <div>
          <Dialog visible={deleteIntervention} style={{ width: '450px' }} header="Confirmação" modal footer={deleteInterventionFooter} onHide={hidedeleteIntervention}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {intervention && (
              <span>
                Você tem certeza que deseja excluir
                <br />
                <br />
                <b>{intervention.natureza_interv_descricao}</b>
                ?
              </span>
              )}
            </div>
          </Dialog>

          <Dialog visible={deleteInterventionsDialog} style={{ width: '450px' }} header="Confirmação" modal footer={deleteInterventionsDialogFooter} onHide={hidedeleteInterventionsDialog}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {intervention
              && <span>Você tem certeza que deseja excluir os cadastros selecionados?</span>}
            </div>
          </Dialog>
        </div>

      </div>

    </Container>

  );
};

export default Intervention;
